export const internalDateFormat = {
    flatpickr: 'Y-m-dTH:i',
    moment: 'YYYY-MM-DDTHH:mm',
};
export const attributesToCopy = [
    'aria-describedby',
    'aria-invalid',
    'aria-label',
    'aria-required',
    'autocomplete',
];
//# sourceMappingURL=constants.js.map